import React from "react";
import { Check, Plus, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import { coachingFAQData } from '@/data/faq/coaching-faq';

const FAQSection = () => {
  const faqItems = coachingFAQData;

  return (
    <section id="faq" className="section-spacing bg-white">
      <StructuredDataFAQ faqItems={faqItems} pageName="Coaching" />
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Deine Fragen zum Coaching
          </h2>
          <p className="mt-4 text-joerg-600">
            Hier findest du Antworten auf häufig gestellte Fragen. Falls deine Frage nicht dabei ist, kontaktiere mich gerne direkt.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="mb-8">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`item-${index + 1}`} className="border-b border-joerg-200">
                <AccordionTrigger className="text-lg font-medium py-4 hover:no-underline hover:text-primary">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent forceMount className="pt-2 pb-4">
                  <p className="text-joerg-600 text-left">{item.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
            
            
            <AccordionItem value="item-start" className="border-b border-joerg-200">
              <AccordionTrigger className="text-lg font-medium py-4 hover:no-underline hover:text-primary">
                Wie läuft das Erstgespräch ab?
              </AccordionTrigger>
              <AccordionContent forceMount className="pt-2 pb-4">
                <p className="text-joerg-600 text-left">
                  Im kostenlosen Erstgespräch klären wir, ob und wie ich dich unterstützen kann. Du schilderst mir deine Situation und deine Ziele, und ich erkläre dir meinen Ansatz und meine Arbeitsweise.
                </p>
                <p className="mt-4 text-joerg-600 text-left">
                  <span className="text-primary-700 font-medium">Hinweis:</span> Selbstverständlich biete ich auf Wunsch auch die formelle Ansprache (Sie-Form) an – ganz nach deiner persönlichen Präferenz.
                </p>
              </AccordionContent>
            </AccordionItem>
            
            <AccordionItem value="item-when" className="border-b border-joerg-200">
              <AccordionTrigger className="text-lg font-medium py-4 hover:no-underline hover:text-primary">
                Wann ist Finanzcoaching sinnvoll?
              </AccordionTrigger>
              <AccordionContent forceMount className="pt-2 pb-4">
                <p className="text-joerg-600">
                  Finanzcoaching ist besonders hilfreich in diesen Situationen:
                </p>
                <ul className="mt-3 space-y-2">
                  <li className="flex items-start gap-2">
                    <Plus className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                    <span className="text-joerg-600">Du möchtest deine finanzielle Situation strukturieren und einen besseren Überblick gewinnen</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Plus className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                    <span className="text-joerg-600">Du stehst vor wichtigen finanziellen Entscheidungen und benötigst eine neutrale Reflexion</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Plus className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                    <span className="text-joerg-600">Du hast das Gefühl, dass deine Beziehung zu Geld durch Glaubenssätze oder Emotionen belastet ist</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Plus className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                    <span className="text-joerg-600">In Partnerschaften oder Familien gibt es Konflikte rund um das Thema Geld</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Plus className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                    <span className="text-joerg-600">Du möchtest deine finanzielle Bildung verbessern und unabhängig von Produktverkäufern lernen</span>
                  </li>
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
          
          <div className="text-center mt-8">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-full font-medium transition-colors"
            >
              Weitere Fragen? Kontaktiere mich
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;